/**
 * Azure AD / Microsoft Entra ID Configuration
 *
 * Single source of truth for frontend Microsoft authentication settings.
 *
 * ── Hardcoded defaults ──────────────────────────────────
 * These values come from your Azure app registrations.
 * Update them when rotating clients or switching tenants.
 *
 * ── Runtime overrides (localStorage) ────────────────────
 * Settings → Integrations page writes to these keys.
 * Useful for local development or per-environment config.
 *
 *   localStorage key            | Overrides
 *   ────────────────────────────┼──────────────────────────
 *   azure_tenant_id             | tenantId
 *   azure_client_id             | clientId
 *   azure_api_scope             | apiScope
 *   azure_redirect_uri          | redirectUri
 *
 * ── How to update ───────────────────────────────────────
 * For production: edit the defaults below directly.
 * For local dev:   use Settings → Integrations in the UI,
 *                  or set localStorage keys via devtools.
 */

export const AZURE_AD = {
    /** Microsoft Entra ID tenant (directory) ID */
    tenantId: '50e83a31-4f77-43e1-830f-a4eb1a718df6',

    /** SPA (UI) app registration client ID — used by MSAL in the browser */
    clientId: '69723130-23dc-4151-a2ad-efa069558f14',

    /** API scope the UI requests. Must match the API app registration's exposed scope. */
    apiScope: 'api://8df2c370-7096-4d4d-b6b6-4d9319fceff3/user_impersonation',

    /**
     * Redirect URI override (empty = auto-detect from window.location).
     * Set this for local development, e.g. http://localhost:8080
     */
    redirectUri: ''
};

/**
 * Read a config value with localStorage fallback.
 * @param {'tenantId'|'clientId'|'apiScope'|'redirectUri'} key
 * @returns {string}
 */
export function getAzureConfig(key) {
    const storageMap = {
        tenantId: 'azure_tenant_id',
        clientId: 'azure_client_id',
        apiScope: 'azure_api_scope',
        redirectUri: 'azure_redirect_uri'
    };
    const storageKey = storageMap[key];
    if (storageKey) {
        const stored = localStorage.getItem(storageKey);
        if (stored?.trim()) return stored.trim();
    }
    return AZURE_AD[key] || '';
}
